import { render, staticRenderFns } from "./BoardListDefaultLayout.vue?vue&type=template&id=6e180622&scoped=true&"
import script from "./BoardListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e180622",
  null
  
)

export default component.exports